import { useState, useEffect, useCallback } from 'react';
import logo from '@/images/logo.png';

const navLinks = [
  { label: 'Inicio', href: '#hero' },
  { label: 'Nuestro impacto', href: '#impacto' },
  { label: 'Soluciones', href: '#soluciones' },
  { label: 'FAQ', href: '#faq' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Scroll suave a la sección en vez de saltar directo con el ancla nativa
  const handleNavClick = useCallback((e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setMobileOpen(false);
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? 'py-3' : 'py-5'
      }`}
      style={{
        background: scrolled
          ? 'rgba(255, 255, 255, 0.92)'
          : 'transparent',
        backdropFilter: scrolled ? 'blur(24px)' : 'none',
        WebkitBackdropFilter: scrolled ? 'blur(24px)' : 'none',
        borderBottom: scrolled
          ? '1px solid rgba(0, 0, 0, 0.06)'
          : '1px solid transparent',
        transition: 'all 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
      }}
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 flex items-center justify-between">
        <a href="#hero" onClick={(e) => handleNavClick(e, '#hero')} className="flex items-center gap-3 group">
            <img
              src={logo}
              alt="Crece Prestaciones"
              className="h-14 w-auto transition-all duration-300 group-hover:scale-105"
            />
        </a>

        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => handleNavClick(e, link.href)}
              className={`relative px-4 py-2 text-sm font-medium transition-colors duration-300 group whitespace-nowrap ${
                scrolled ? 'text-foreground-600 hover:text-foreground-950' : 'text-foreground-600 hover:text-foreground-950'
              }`}
            >
              {link.label}
              <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-0 h-[2px] bg-accent-500 rounded-full transition-all duration-300 group-hover:w-4/5"></span>
            </a>
          ))}
        </div>

        <div className="hidden md:block">
          <a
            href="#contacto"
            onClick={(e) => handleNavClick(e, '#contacto')}
            className="inline-flex items-center gap-2 px-5 py-2.5 bg-accent-500 text-white text-sm font-semibold rounded-full hover:bg-accent-600 transition-all duration-300 hover:scale-[1.04] active:scale-[0.97] cursor-pointer whitespace-nowrap"
          >
            Solicitar Crédito
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
          aria-label="Menú"
        >
          <i className={`text-2xl transition-all duration-300 ${mobileOpen ? 'ri-close-line rotate-90' : 'ri-menu-3-line'}`}></i>
        </button>
      </div>

      <div
        className={`md:hidden overflow-hidden transition-all duration-400 ${
          mobileOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="mx-4 mt-3 p-4 rounded-2xl bg-white/95 backdrop-blur-xl border border-foreground-100 shadow-lg flex flex-col gap-1">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => handleNavClick(e, link.href)}
              className="px-4 py-3 text-sm font-medium text-foreground-600 hover:text-foreground-950 hover:bg-accent-50 rounded-xl transition-all duration-200 whitespace-nowrap"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#contacto"
            onClick={(e) => handleNavClick(e, '#contacto')}
            className="mt-2 flex items-center justify-center gap-2 px-5 py-3 bg-accent-500 text-white text-sm font-semibold rounded-full hover:bg-accent-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            Solicitar Crédito
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </nav>
  );
}